module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "glossary"
    }
  }, [_c('h1', [_vm._v("ワルツ(Waltz)について")]), _vm._v("\n\n  ここではワルツ(Waltz)を紹介します。SetDancePalの中の人は実はワルツが一番好きです。誤りなどありましたらご指摘ください。オススメのワルツも募集中です。\n  "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n  セットダンスと同じく、ジェンツは左足から、レディーは右足から動きます。ワルツには特定の型があるものや、型のない自由に動くものもあります。\n  "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-card', {
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("St.Bernard Waltz")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("セント・バーナード・ワルツ")])]), _vm._v(" "), _c('md-card-content', [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": "https://www.youtube.com/embed/U5SML9l59ns?start=9",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-tabs', {
    attrs: {
      "md-fixed": ""
    }
  }, [_c('md-tab', {
    attrs: {
      "id": "movies",
      "md-label": "Gents"
    }
  }, [_c('ol', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('li', [_vm._v("左に三歩進んで足踏み、またはUp/Dwon")]), _vm._v(" "), _c('li', [_vm._v("右に二歩進んで、後ろに2歩下がる")]), _vm._v(" "), _c('li', [_vm._v("前に二歩進んで、左手でレディーを時計回りにターンさせる")]), _vm._v(" "), _c('li', [_vm._v("Waltz holdになって軽く動きながらHomeを2回する")])])]), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "music",
      "md-label": "Ladies"
    }
  }, [_c('ol', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('li', [_vm._v("右に三歩進んで足踏み、またはUp/Dwon")]), _vm._v(" "), _c('li', [_vm._v("左に二歩進んで、前に2歩進む")]), _vm._v(" "), _c('li', [_vm._v("後ろに二歩下がって、時計回りにターンする")]), _vm._v(" "), _c('li', [_vm._v("Waltz holdになって軽く動きながらHomeを2回する")])])])], 1)], 1)], 1), _vm._v(" "), _c('md-card', {
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Waltz of the bells")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("セント・オブ・ザ・ベルズ")])]), _vm._v(" "), _c('md-card-content', [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": "https://www.youtube.com/embed/kcYO_eLrFuQ?start=9",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-tabs', {
    attrs: {
      "md-fixed": ""
    }
  }, [_c('md-tab', {
    attrs: {
      "id": "movies",
      "md-label": "Gents"
    }
  }, [_c('ol', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('li', [_vm._v("体を左、右、左、右、の順に開く。体を開く方向とは逆側の足を上げる")]), _vm._v(" "), _c('li', [_vm._v("反時計回りにターンしてパートナーと向き合い、両手をつないで左に二歩進む")]), _vm._v(" "), _c('li', [_vm._v("体を右、左、右、左、の順に開く。体を開く方向とは逆側の足を上げる")]), _vm._v(" "), _c('li', [_vm._v("時計回りにターンしてパートナーと向き合い、両手をつないで右に二歩進む")]), _vm._v(" "), _c('li', [_vm._v("左に二歩進んで、左手でレディーを時計回りにターンさせる")]), _vm._v(" "), _c('li', [_vm._v("右に二歩進んで、右手でレディーを反時計回りにターンさせる")]), _vm._v(" "), _c('li', [_vm._v("両手をつないだまま、閉じて、開いて、閉じて、開いてを繰り返す")]), _vm._v(" "), _c('li', [_vm._v("Waltz holdになって軽く動きながらHomeを2回する")])])]), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "music",
      "md-label": "Ladies"
    }
  }, [_c('ol', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('li', [_vm._v("体を右、左、右、左、の順に開く。体を開く方向とは逆側の足を上げる")]), _vm._v(" "), _c('li', [_vm._v("時計回りにターンしてパートナーと向き合い、両手をつないで右に二歩進む")]), _vm._v(" "), _c('li', [_vm._v("体を左、右、左、右、の順に開く。体を開く方向とは逆側の足を上げる")]), _vm._v(" "), _c('li', [_vm._v("反時計回りにターンしてパートナーと向き合い、両手をつないで左に二歩進む")]), _vm._v(" "), _c('li', [_vm._v("右に二歩進んで、反時計回りにターンする")]), _vm._v(" "), _c('li', [_vm._v("左に二歩進んで、時計回りにターンする")]), _vm._v(" "), _c('li', [_vm._v("両手をつないだまま、閉じて、開いて、閉じて、開いてを繰り返す")]), _vm._v(" "), _c('li', [_vm._v("Waltz holdになって軽く動きながらHomeを2回する")])])])], 1)], 1)], 1), _vm._v(" "), _c('md-divider'), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("copyright © 2017-" + _vm._s(new Date().getFullYear()) + " Hiroshi Jo")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8abb1826","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Waltz.vue
// module id = 339
// module chunks = 1